import { CSSProperties } from "react";
import useApp from "../context/AppContext";

const ModalMsg = () => {
  const divStyle: CSSProperties = {
    zIndex: 150,
  };
  const modalStyle: CSSProperties = {
    width: "600px",
    position: "fixed",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 151,
  };
  const { showModal, modalTitle, modalBody, closeModal } = useApp();

  return !showModal?(<></>):(
    <div className="">
      <div className="fade modal-backdrop show" style={divStyle} onClick={closeModal} ></div>
      <div className={" min-450 rounded-0"} style={modalStyle}>
        <div className="modal__content">
          <h1>{modalTitle}</h1>            
          {modalBody}
            <button className="modal__close" onClick={closeModal}>&times;</button>
        </div>
      </div>
    </div>
  );
};

export default ModalMsg;
